import * as React from 'react';
import {
    Button, ButtonType
} from 'office-ui-fabric-react';
import Collapsible from 'react-collapsible';
import SummaryDialogContainer from '../../containers/summary-dialog';

interface IProps {
    componentId: string;
    toggleJourneySummaryDialog: (componentId: string, previousOutputBlocks: any) => void;
    previousOutputBlocks: any;
}
let childElement: JSX.Element;

export class Summary extends React.Component<IProps, any> {
    getChildren() {
        childElement = <SummaryDialogContainer />;
    }

    componentDidMount(): void {
        // let { componentId, toggleJourneySummaryDialog, previousOutputBlocks } = this.props;
        // toggleJourneySummaryDialog(componentId, previousOutputBlocks)
        this.getChildren();
    }


    render() {

        // let { componentId, toggleJourneySummaryDialog, previousOutputBlocks } = this.props;


        return (
            <div>
                {childElement}

                {/* <Button buttonType={ButtonType.primary}
                label='Configure this loop'
                title='Configure this loop'
                icon='Settings'
                onClick={(e) => toggleLoopConfigDialog(componentId)} /> */}

                {/* <Collapsible onClick={(e) => { toggleJourneySummaryDialog(componentId, previousOutputBlocks), this.getChildren() }}
                    trigger={''
                    } open={true} >
                    {childElement}
                </Collapsible> */}

            </div>
        );

        // return <Button buttonType={ButtonType.primary}
        //     label='Configure journey summary'
        //     title='Configure journey summary'
        //     icon='Settings'
        //     onClick={(e) => toggleJourneySummaryDialog(componentId, previousOutputBlocks)} />;
    }

}


// WEBPACK FOOTER //
// ./source/ts/components/components/summary.tsx